import { render, staticRenderFns } from "./fieldtype_percent.vue?vue&type=template&id=e4afa426&scoped=true&"
import script from "./fieldtype_percent.vue?vue&type=script&lang=js&"
export * from "./fieldtype_percent.vue?vue&type=script&lang=js&"
import style0 from "./fieldtype_percent.vue?vue&type=style&index=0&id=e4afa426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4afa426",
  null
  
)

export default component.exports